import { render, staticRenderFns } from "./PaymentTransactionList.vue?vue&type=template&id=581946c4&"
import script from "./PaymentTransactionList.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports